import React from "react";
import { FaBackspace } from "react-icons/fa";

const TextField = (props) => {
    return (
        <div className='relative mb-2 flex min-h-[2rem] w-full max-w-[15rem] flex-1 items-center justify-center text-center text-2xl	 tracking-widest'>
            <span className='d-block'>{"*".repeat(props.inputLength)}</span>
            <FaBackspace
                onClick={props.clickHandler}
                className='absolute right-0 top-[-7.5px] cursor-pointer text-4xl'
            />
        </div>
    );
};

export default TextField;
